import { render, staticRenderFns } from "./layout-header.vue?vue&type=template&id=6808127b&scoped=true"
import script from "./layout-header.vue?vue&type=script&lang=js"
export * from "./layout-header.vue?vue&type=script&lang=js"
import style0 from "./layout-header.vue?vue&type=style&index=0&id=6808127b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6808127b",
  null
  
)

export default component.exports